import { useEffect, useState } from "react"
import { X } from "lucide-react"

export function AddCategoryForm({ categoryItem, onClose, onSubmit }) {
    const [name, setName] = useState("")
    const [imageURL, setImageURL] = useState("")

    useEffect(() => {
        if(categoryItem)
        {
            setName(categoryItem.categoryName)
            setImageURL(categoryItem.categoryImage)
        }
    }, [])

    const handleSubmit = (e) => {
        e.preventDefault()
        onSubmit({
            "categoryName": name,
            "image": imageURL  ,
            "status": "active"
        })
    }

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" style={{zIndex:501}}>
            <div className="bg-white rounded-lg shadow-lg w-full max-w-md">
                <div className="flex items-center justify-between p-4 border-b">
                    <h2 className="text-lg font-semibold">Add New Category</h2>
                    <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
                        <X className="w-5 h-5" />
                    </button>
                </div>

                <form onSubmit={handleSubmit} className="p-4">
                    <div className="space-y-2">
                        <div className="space-y-2">
                            <label htmlFor="categoryName" className="block text-sm font-medium text-gray-700">
                                Category Name*
                            </label>
                            <input
                                id="categoryName"
                                type="text"
                                required
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md"
                            />
                        </div>
                        <div className="space-y-2">
                            <label htmlFor="categoryName" className="block text-sm font-medium text-gray-700">
                                Category Image URL*
                            </label>
                            <input
                                id="categoryName"
                                type="text"
                                value={imageURL}
                                onChange={(e) => setImageURL(e.target.value)}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md"
                            />
                        </div>
                    </div>

                    <div className="mt-6 flex justify-end space-x-3">
                        <button
                            type="button"
                            onClick={onClose}
                            className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="px-4 py-2 bg-green-600 rounded-md text-sm font-medium text-white hover:bg-blue-700"
                        >
                            {categoryItem ? 'Update Category' : 'Add Category' } 
                        </button>
                    </div>
                </form>
            </div>
        </div>
    )
}

